import axios from "axios"

export const postRequest = (url, reqBody = {}, headers = {}) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"

      const { data } = await axios.post(url, reqBody, headers)

      if (data.error && !data.success) throw data.errorCode

      // console.log(data)

      resolve(data)
    } catch (error) {
      reject(error)
    }
  })
}

export const patchRequest = (url, reqBody = {}, headers = {}) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"

      const { data } = await axios.patch(url, reqBody, headers)

      if (data.error && !data.success) throw data.errorCode

      resolve(data)
    } catch (error) {
      reject(error)
    }
  })
}

export const getRequest = (url, config = {}) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"

      const { data } = await axios.get(url, config)

      if (data.error && !data.success) throw data.errorCode

      // console.log(data)

      resolve(data)
    } catch (error) {
      reject(error)
    }
  })
}

export const deleteRequest = (url, config = {}) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"

      const { data } = await axios.delete(url, config)

      if (data.error && !data.success) throw data.errorCode

      // console.log(data)

      resolve(data)
    } catch (error) {
      reject(error)
    }
  })
}
